import React, { useEffect, useState } from 'react';
import { Table, message } from 'antd';
import ProjectServices from '../../../../services/projectServices';
import { getTranslation } from '../../../../util/utilFunc';
import { useSelector } from 'react-redux';

function OrganisationManagement() {
  const [organisations, setOrganisations] = useState([]);
  const { language } = useSelector((state) => state.auth);

  useEffect(() => {
    fetchOrganisations();
  }, []);

  const fetchOrganisations = async () => {
    try {
      const response = await ProjectServices.getAllOrganisations();
      setOrganisations(response.data);
    } catch (error) {
      message.error(getTranslation('Failed to fetch organisations', language));
    }
  };

  const columns = [
    {
      id: 'ID',
      dataIndex: 'id',
      key: 'id'

    },
    {
      title: 'Organisation Name',
      dataIndex: 'name',
      key: 'name',
    },
    // Add more columns as needed
  ];

  return (
    <div>
      <h2>{getTranslation('Organisation Management', language)}</h2>
      <Table
        columns={columns}
        dataSource={organisations}
        rowKey="id" // Adjust this key based on your data
      />
    </div>
  );
}

export default OrganisationManagement;
